<span
    (click)="openHelpPage()"
    title="{{title}}">
    <i class="nlrp-icon nlrp-icon-help nlrp-18"></i>
</span>
